import { defineStore } from 'pinia'
import type { Segment } from '~/types'

export const useSegmentStore = defineStore('segment', {
    state: () => ({
        contactsSegments: [] as Segment[],
        currentContactSegment: null as Segment | null,
        contactsSegmentsLoaded: false,

        companiesSegments: [] as Segment[],
        currentCompanySegment: null as Segment | null,
        companiesSegmentsLoaded: false,
    }),

    actions: {
        setContactsSegments(segments: Segment[]) {
            this.contactsSegments = segments
        },
        setCurrentContactSegment(segment: Segment) {
            this.currentContactSegment = segment
        },
        setCompaniesSegments(segments: Segment[]) {
            this.companiesSegments = segments
        },
        setCurrentCompanySegment(segment: Segment) {
            this.currentCompanySegment = segment
        },
        async fetchContactsSegments() {
            if (this.contactsSegmentsLoaded) return

            const { $api } = useNuxtApp();

            await $api.get("/segments/contacts")
                .then((response) => {
                    this.setContactsSegments(response.data);
                    this.currentContactSegment = response.data[0];
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.contactsSegmentsLoaded = true;
                })
        },
        async fetchCompaniesSegments() {
            if (this.companiesSegmentsLoaded) return

            const { $api } = useNuxtApp();

            await $api.get("/segments/companies")
                .then((response) => {
                    this.setCompaniesSegments(response.data);
                    this.currentCompanySegment = response.data[0];
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.companiesSegmentsLoaded = true;
                })
        },
        clear() {
            this.contactsSegments = []
            this.currentContactSegment = null
            this.companiesSegments = []
            this.currentCompanySegment = null
            this.contactsSegmentsLoaded = false
            this.companiesSegmentsLoaded = false
        }
    }
})